import { Typography } from '@mui/material'

const HelpText = () => {

  return (
    <div className='p-5'>
      <Typography variant='h5' className='pb-5'>Reset Password</Typography>
      <p>You have requested a password reset and have followed a link we have emailed to you.</p>
      <p>Choose and enter a new password.</p>
      <p>The link is only valid for 10 minutes. If it has expired, please request a new one.</p>
    </div>
  )
}

export default HelpText